export default __webpack_public_path__ + "static/media/fortune-energy.7ee84809.png";